import { Option } from "../../models/option";

export const tournamentStages: Option[] = [
  {name: 'draft', value: 'DRAFT'},
  {name: 'groups', value: 'GROUPS'},
  {name: 'rounds', value: 'ROUNDS'},
  {name: 'playoffs', value: 'PLAYOFFS'},
  {name: 'finished', value: 'FINISHED'},
];